import { api, getAuthHeader } from "../axiosConfig";
import { notifyService } from "./notifyService";

export async function globalSearch({ q, types, cid }) {
  return await api
    .get("/search", {
      params: { q, types, cid: cid || undefined },
      headers: getAuthHeader(),
    })
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      notifyService("Search failed");
      return null;
    });
}
